import { isObject, isBoolean, isDateString, isArray } from 'utils/typeUtils';
import { isNumber } from '../utils/typeUtils';
import { convertUTCStringIntoJSTString, DATE_FORMAT } from '../utils/dateUtils';
import { OriginalMenu } from './menu';

/**
 * 契約一覧のアイテム from api
 */
export type OriginalContract = {
  id: number;
  customerId: number;
  menuId: number;
  startDate: string;
  endDate: string;
  suspended: boolean;
};

/**
 * 契約一覧のアイテム from api の型ガード
 */
const isOriginalContract = (arg: unknown): arg is OriginalContract => {
  const a = arg as OriginalContract;

  return (
    isObject(a) &&
    isNumber(a.id) &&
    isNumber(a.customerId) &&
    isNumber(a.menuId) &&
    isDateString(a.startDate) &&
    isDateString(a.endDate) &&
    isBoolean(a.suspended)
  );
};

/**
 * 契約一覧 from api の配列の型ガード
 */
export const isOriginalContracts = (
  arg: unknown,
): arg is OriginalContract[] => {
  const a = arg as OriginalContract[];

  return isObject(a) && isArray<OriginalContract>(a, isOriginalContract);
};

/**
 * 契約一覧のアイテム for ui
 */
export type Contract = {
  id: number;
  customerId: number;
  menuId: number;
  menuName: string;
  startDate: string;
  endDate: string;
  valid: boolean; // 有効(suspended を反転させている)
};

/**
 * 契約一覧のアイテム for ui を生成する
 */
export const createContract = (
  item: OriginalContract,
  menuMap: { [key: number]: OriginalMenu },
): Contract => {
  const contract: Contract = {
    id: item.id,
    customerId: item.customerId,
    menuId: item.menuId,
    menuName: menuMap[item.menuId] ? menuMap[item.menuId].name : '',
    startDate: convertUTCStringIntoJSTString(item.startDate, DATE_FORMAT.DATE),
    endDate: convertUTCStringIntoJSTString(item.endDate, DATE_FORMAT.DATE),
    valid: !item.suspended,
  };

  return contract;
};

/**
 * 契約作成用
 */
export type NewContract = Pick<
  Contract,
  'customerId' | 'menuId' | 'startDate' | 'endDate'
>;

/**
 * 契約更新用
 */
export type UpdateContract = Pick<
  Contract,
  'customerId' | 'menuId' | 'startDate' | 'endDate'
> & {
  suspended: boolean;
};
